import Vue from 'vue'

import AppMain from '@/components/app-main'
import router from '@/router.js'
import SizesMixin from '@/mixins/Sizes'

import config from '@/config.js'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
/* eslint-enable */
    el: '#app',

    router,

    components: { AppMain },

    template: '<app-main/>',

    mixins:
    [
        SizesMixin
    ],

    watch:
    {
        $route(value, oldValue)
        {
            this.$previousRoute = oldValue
        }
    },

    created()
    {
        this.config = config

        this.setGrid()
    },

    methods:
    {
        setGrid()
        {
            this.grid = {}

            this.grid.amplitude = 0
            this.grid.countX = 0
            this.grid.countY = 0
            this.grid.flooredCountX = 0
            this.grid.flooredCountY = 0
            this.grid.offsetX = 0
            this.grid.offsetY = 0

            this.grid.resize = () =>
            {
                let containerWidth = null

                // Amplitude
                if(this.sizes.width > 1600)
                {
                    containerWidth = 1120
                }
                else if(this.sizes.width > 1200)
                {
                    containerWidth = 1000
                }
                else if(this.sizes.width > 1024)
                {
                    containerWidth = 800
                }
                else
                {
                    containerWidth = 700
                }

                // Amplitude
                this.grid.amplitude = containerWidth / 3

                // Counts
                this.grid.countX = this.sizes.width / this.grid.amplitude
                this.grid.countY = this.sizes.height / this.grid.amplitude

                this.grid.flooredCountX = Math.ceil(this.grid.countX)
                this.grid.flooredCountY = Math.ceil(this.grid.countY)

                // Offsets
                const leftMargin = (this.sizes.width - containerWidth) / 2
                this.grid.offsetX = leftMargin - Math.floor(leftMargin / this.grid.amplitude) * this.grid.amplitude
                this.grid.offsetY = Math.round((this.sizes.height - this.grid.flooredCountY * this.grid.amplitude) / 2)

                // Round amplitude
                this.grid.amplitude = Math.round(this.grid.amplitude)
            }
            this.grid.resize()
        },

        onResize()
        {
            this.grid.resize()
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js